import React from 'react';
import { Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Carousel } from 'lunchbox';

import { BREAK_POINTS } from '../util/breakpoint';
import { useMediaQuery } from '../util/useMediaQuery';

const PromoBanner = ({ sliderImageList }) => {
  const isDesktop = useMediaQuery(BREAK_POINTS.desktop);
  const isTablet = useMediaQuery(BREAK_POINTS.tablet);
  const isLargeDisplay = isTablet || isDesktop;

  let currentStep = 0;
  if (typeof document !== 'undefined') {
    const params = new URLSearchParams(document.location.search);
    currentStep = Number(params.get('slide'));
  }

  const renderPromoSlides = (slides) => {
    const slideList = slides.filter(
      (_slide, index) =>
        sliderImageList.slideshow[index].customData.isDesktop
        === (isLargeDisplay ? 'true' : 'false')
    );
    return slideList.map((item, index) =>
      (
        <div key={item.url}>
          <Link
            to={item.redirectURL || '#'}
            rel="noopener noreferrer"
            className="slide slide__item flex flex-col"
            id={`slide-${index + 1}`}
          >
            <GatsbyImage
              image={getImage(slideList[index].gatsbyImageData)}
              alt={slideList[index].basename}
            />
          </Link>
        </div>
      ));
  };

  return (
    <Carousel
      totalSlides={3}
      visibleSlides={1}
      currentStep={currentStep}
      isInfinite
      shouldPlay
      slides={sliderImageList.slideshow}
      renderSlides={renderPromoSlides}
      showDotGroup
      className="promo__banner--container"
      interval={5000}
    />
  );
};

export default PromoBanner;
